import { ExpenseProduct } from "./expense";
import { SubProduct } from "../subproduct/subproduct";

export class Product {
    cat: number;
    class: string;
    color: string;
    count: number;
    dataLength: number;
    expenses: Array<ExpenseProduct>;
    id: string;
    margin: string;
    ordinal: number;
    price: number;
    priceText: string;
    showLine: true;
    title: string;
    titleShort: string;
    subproducts: Array<SubProduct>;
    widthContainer: string;
    constructor(data) {
        this.cat = data.cat;
        this.class = data.class;
        this.color = data.color;
        this.count = data.count;
        this.dataLength = data.dataLength;
        if (data.expenses)
        {
            this.expenses = data.expenses.map((item) => new ExpenseProduct(item));
        }
       
        this.id = data.id;
        this.margin = data.margin;
        this.ordinal = data.ordinal;
        this.price = data.price;
        this.priceText = data.priceText;
        this.showLine = data.showLine;
        this.title = data.title;
        this.titleShort = data.titleShort;
        if (data.subproducts)
        {
            this.subproducts = data.subproducts.map((item) => new SubProduct(item));
        }
       
        this.widthContainer = data.widthContainer;

   
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/product/product.ts